import { render, staticRenderFns } from "./DonutChartAdminJobSeeker.vue?vue&type=template&id=613790f6&scoped=true&"
import script from "./DonutChartAdminJobSeeker.vue?vue&type=script&lang=js&"
export * from "./DonutChartAdminJobSeeker.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartAdminJobSeeker.vue?vue&type=style&index=0&id=613790f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613790f6",
  null
  
)

export default component.exports